module.exports = {
  footerText: '.کلیه حقوق برای تم ایکس محفوظ می باشد',
};
